export default __webpack_public_path__ + "static/media/bootstrap.min.css.9376a658.map";